/**
 * NotificationsDropdown — iter186
 *
 * Refactored per user request: the dropdown is gone. The bell is now
 * a direct link to /notifications. It still shows the unread badge
 * (polled every 60s), but there's no in-header popover — every click
 * takes the user to the full notifications page where they can read
 * the details modal and act on the CTA.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { apiClient } from "../lib/api";
import { useAuth } from "../lib/auth";

// eslint-disable-next-line no-unused-vars
export default function NotificationsDropdown({ lang }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    let mounted = true;
    const refresh = async () => {
      try {
        const { data } = await apiClient.get("/notifications/unread-count");
        if (mounted) setCount(data.count || 0);
      } catch {/* silent */}
    };
    refresh();
    const i = setInterval(refresh, 60000);
    return () => { mounted = false; clearInterval(i); };
  }, [user]);

  if (!user) return null;

  return (
    <Link
      to="/notifications"
      className="relative inline-flex items-center justify-center w-11 h-11 rounded-full text-[#525252] hover:text-[#0a0a0a] hover:bg-[#0a0a0a]/[0.05] transition-colors"
      aria-label="Notifications"
      data-testid="notif-bell"
    >
      <Bell className={`w-[18px] h-[18px] ${count > 0 ? "text-[#a8893e]" : ""}`} />
      {count > 0 && (
        <span
          className="absolute top-1 end-1 min-w-[16px] h-[16px] px-[3px] rounded-full bg-[#c9a55c] text-[#0a0a0a] text-[9px] font-bold flex items-center justify-center"
          data-testid="notif-bell-count"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
